module.exports = __webpack_public_path__ + "static/media/dramaImg1.631ffe75.jpg";